export const actionTypes = {
    SET_COMMON_ERROR: 'SET_COMMON_ERROR',
    CLEAR_COMMON_ERROR: 'CLEAR_SET_COMMON_ERROR',
    SIDE_MENU_OPENED: 'SIDE_MENU_OPENED',
    SIDE_MENU_CLOSED: 'SIDE_MENU_CLOSED',
    SET_PAGE_NOTIFICATION: 'SET_PAGE_NOTIFICATION',
    CLEAR_PAGE_NOTIFICATION: 'CLEAR_PAGE_NOTIFICATION',
    SAGA_FETCH_ADP_CONFIGURATIONS: 'SAGA_FETCH_ADP_CONFIGURATIONS',
    FETCH_ADP_CONFIGURATIONS_SUCCESS: 'FETCH_ADP_CONFIGURATIONS_SUCCESS',
    FETCH_ADP_CONFIGURATIONS_FAILED: 'FETCH_ADP_CONFIGURATIONS_FAILED',
    CONFIG_LOADING_START: 'CONFIG_LOADING_START',
    CONFIG_LOADING_END: 'CONFIG_LOADING_END',
    FETCHING_LANGUAGE_START: 'FETCHING_LANGUAGE_START',
    FETCHING_LANGUAGE_END: 'FETCHING_LANGUAGE_END',
    SET_CONFIGURATION_RESTRICTION: 'SET_CONFIGURATION_RESTRICTION',
    CLEAR_CONFIGURATION_RESTRICTION: 'CLEAR_CONFIGURATION_RESTRICTION',
}

export const setConfigurationRestriction = message => ({
    type: actionTypes.SET_CONFIGURATION_RESTRICTION,
    payload: message,
})

export const clearConfigurationRestriction = () => ({
    type: actionTypes.CLEAR_CONFIGURATION_RESTRICTION,
})

export const configLoadingStart = () => ({
    type: actionTypes.CONFIG_LOADING_START,
})

export const configLoadingEnd = () => ({
    type: actionTypes.CONFIG_LOADING_END,
})

export const fetchingLanguageStart = () => ({
    type: actionTypes.FETCHING_LANGUAGE_START,
})

export const fetchingLanguageEnd = () => ({
    type: actionTypes.FETCHING_LANGUAGE_END,
})

export const fetchADPConfigurations = () => ({
    type: actionTypes.SAGA_FETCH_ADP_CONFIGURATIONS,
})

export const fetchADPConfigurationsSuccess = data => ({
    type: actionTypes.FETCH_ADP_CONFIGURATIONS_SUCCESS,
    payload: data,
})

export const fetchADPConfigurationsFailed = () => ({
    type: actionTypes.FETCH_ADP_CONFIGURATIONS_FAILED,
})

export const setCommonError = error => ({
    type: actionTypes.SET_COMMON_ERROR,
    payload: error,
})

export const clearCommonError = () => ({
    type: actionTypes.CLEAR_COMMON_ERROR,
})

export const sideMenuOpened = () => ({
    type: actionTypes.SIDE_MENU_OPENED,
})

export const sideMenuClosed = () => ({
    type: actionTypes.SIDE_MENU_CLOSED,
})

export const setPageNotification = payload => ({
    type: actionTypes.SET_PAGE_NOTIFICATION,
    payload,
})

export const clearPageNotification = () => ({
    type: actionTypes.CLEAR_PAGE_NOTIFICATION,
})
